import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {SecurityUserService} from '../../../services/security/security-user.service';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {FieldRequest} from '../../../model/api/field-request';
import {FieldRecord} from '../../../model/api/field-record';
import {CommonFieldService} from '../../../services/common/common-field.service';
import {CrudBaseComponent} from '../../../crystal-elements/crud/crud-base.component';
import {CCRolesType} from "../../../model/security/cc-roles-type";
import {UserGroup} from "../../../model/security/user-group";
import {SecurityUserGroupService} from "../../../services/security/security-user-group.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-security-user-group',
  templateUrl: './user-group.component.html',
  styleUrls: ['./user-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class UserGroupComponent extends CrudBaseComponent<UserGroup> {

  // fields
  authorities: FieldRecord<any>[];
  users: FieldRecord<any>[];

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              private userService: SecurityUserService,
              userGroupService: SecurityUserGroupService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = userGroupService;
    this.newRecord = new UserGroup();
    this.newRecord.enabled = true;
    this.prepareForEdit = this.prepareRecordForEdit;
    this.prepareForClone = this.prepareRecordForClone;
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'enabled',
        width: 30,
        type: 'BUTTON',
        notFilterable: true,
        notSortable: true,
        notResizable: true,
        class: value => 'centered',
        icon: value => value.enabled ? 'fas fa-toggle-on record-enabled' : 'fas fa-toggle-off record-disabled',
        command: record => {
          this.enable(record);
        },
        mapId: value => ''
      },
      {
        field: 'groupName',
        width: 100,
      }
      ,
      {
        field: 'roles',
        width: 300,
        notFilterable: true,
        notSortable: true,
        toolTip: value => value.roles && value.roles ? value.roles.join(', ') : '',
        mapId: value => value.roles && value.roles ? value.roles.join(', ') : ''
      },
      {
        field: 'usernames',
        notFilterable: true,
        notSortable: true,
        toolTip: value => value.usernames && value.usernames ? value.usernames.join(', ') : '',
        mapId: value => value.usernames && value.usernames ? value.usernames.join(', ') : ''
      }
    ];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'groupName',
            required: true,
            column: 6,
            type: TYPE.TEXT,
          },
          {
            field: 'enabled',
            column: 6,
            type: TYPE.CHECKBOX
          }]
      },
      {
        group: 'roles',
        fields: [
          {
            field: 'roles',
            filter: true,
            column: 12,
            type: TYPE.MULTISELECT_GROUP,
            options: () => this.authorities,
            changed: (event, event2) => {
              if (event && event.value) {
                this.formRecord.roles = event.value;
              } else
                this.formRecord.roles = [];
            }
          },
        ]
      },
      {
        group: 'usernames',
        fields: [
          {
            field: 'usernames',
            filter: true,
            column: 12,
            type: TYPE.MULTISELECT,
            options: () => this.users,
            // changed: (event, event2) => {
            //   console.log("------> users "+JSON.stringify(event.value));
            //   this.formRecord.users = [];
            //   if (event && event.value) {
            //     event.value.forEach(value=>this.formRecord.users.push({'username':value}))
            //     // this.formRecord.users = JSON.parse(JSON.stringify(event.value));
            //   } else
            //     this.formRecord.users = [];
            // }
          },
        ]
      },
    ];

  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getAuthorities(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.authorities = this.getFields(fieldResult);
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getSecurityUsers(FieldRequest.DEFAULT()).subscribe(apiValidation => {
      this.users = this.getFields(apiValidation);
      // this.selectedUser = this.userInfoStorageService.getUsernameFromStorage();
      // this.userChanged();
      this.markForCheck();
      // if (this.ccCrudTable)
      //   this.ccCrudTable.ccFormDialog.reloadFieldValueMap();
      this.settingsFormLoadingProgressValue += 100 / 2;
    });
  }

  prepareRecordForCreate(): void {
    if (this.formRecord) {
    }
  }

  prepareRecordForEdit(): void {
    if (this.formRecord) {
      this.formRecord.originGroupName = this.formRecord.groupName;
    }
  }

  prepareRecordForClone(): void {
    if (this.formRecord) {
      this.formRecord = {...this.formRecord};
      this.formRecord.originGroupName = undefined;
      this.formRecord.groupName = undefined;
    }
  }

  enable(record: UserGroup) {
    if (record) {
      record.enabled = !record.enabled;
      this.formRecord = record;
      this.prepareRecordForEdit();
      this.save();
    }
  }

}
